<template>
  <nav
    class="navbar navbar-expand-lg text-white"
    style="height: auto; width: auto; padding: 10px; background-color: #2e3092"
  >
    <div class="container-fluid">
      <a class="navbar-brand nombreEmpresa" href="/">
        <img
          :src="require('@/assets/logo-mini.webp')"
          alt="Logo"
          width="50"
          height="50"
          class="d-inline-block align-text-center"
        />
        CASA CRU
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav nav-underline ms-auto">
          <li class="nav-item" align="center">
            <v-icon>mdi-home</v-icon>
            <v-btn
              variant="text"
              block
              class="nav-link rutas"
              aria-current="page"
              to="/"
              >INICIO</v-btn
            >
          </li>
          <v-spacer class="espaciado"></v-spacer>
          <li class="nav-item dropdown" align="center">
            <v-icon>mdi-book</v-icon>
            <a
              class="nav-link dropdown-toggle rutas"
              data-bs-toggle="dropdown"
              href="#"
              role="button"
              aria-expanded="false"
              >CATÁLOGOS</a
            >
            <ul class="dropdown-menu">
              <li>
                <v-btn
                  variant="text"
                  block
                  class="nav-link rutas"
                  aria-current="page"
                  to="/bloquera"
                  >BLOQUERA</v-btn
                >
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <v-btn
                  variant="text"
                  block
                  class="nav-link rutas"
                  aria-current="page"
                  to="/productos"
                  >PRODUCTOS</v-btn
                >
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <v-btn
                  variant="text"
                  block
                  class="nav-link rutas"
                  aria-current="page"
                  to="/ofertas"
                  >OFERTAS</v-btn
                >
              </li>
            </ul>
          </li>
          <v-spacer class="espaciado"></v-spacer>
          <li class="nav-item" align="center">
            <v-icon>mdi-briefcase-variant</v-icon>
            <v-btn
              variant="text"
              block
              class="nav-link rutas"
              aria-current="page"
              to="/portafolio"
              >PORTAFOLIO</v-btn
            >
          </li>
          <v-spacer class="espaciado"></v-spacer>
          <li class="nav-item dropdown" align="center">
            <v-icon>mdi-information</v-icon>
            <a
              class="nav-link dropdown-toggle rutas"
              data-bs-toggle="dropdown"
              href="#"
              role="button"
              aria-expanded="false"
              >NOSOTROS</a
            >
            <ul class="dropdown-menu">
              <li>
                <v-btn
                  variant="text"
                  block
                  class="nav-link rutas"
                  aria-current="page"
                  to="/about"
                  >Sobre Nosotros</v-btn
                >
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <v-btn
                  variant="text"
                  block
                  class="nav-link rutas"
                  aria-current="page"
                  to="/sucursales"
                  >Sucursales</v-btn
                >
              </li>
            </ul>
          </li>
          <v-spacer class="espaciado"></v-spacer>
          <li class="nav-item" align="center">
            <v-badge color="error" :content="itemCount">
              <v-icon>mdi-cart</v-icon>
            </v-badge>

            <v-btn
              variant="text"
              block
              class="nav-link rutas"
              aria-current="page"
              to="/carrito"
              >CARRITO</v-btn
            >
          </li>
          <v-spacer class="espaciado"></v-spacer>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['cartItems']),
    ...mapGetters('cartProduct', ['allCartProducts', 'cartItemCountProduct']),
    itemCount() {
      var count =
        Number(this.cartItemCountProduct) +
        Number(this.$store.getters.cartItemCount);
      return count;
    },
  },
};
</script>

<style scoped>
/* Cambio de color de texto al hacer hover sobre los ítems del navbar */
.nav-item .nav-link:hover {
  color: #e3ad6d !important;
}

/* Estilo para los ítems de dropdown */
.dropdown-menu {
  background-color: #2e3092; /* Ajusta este valor al color de fondo exacto de tu navbar */
}

.dropdown-item {
  color: white;
}
/* Cambio de color de texto y fondo al hacer hover en los ítems de dropdown */
.dropdown-item:hover {
  background-color: #2e3092; /* Para mantener el fondo igual al del navbar */
  color: #e3ad6d !important;
}

/* Opcionalmente, si deseas que el divider en el dropdown también cambie de color (aunque solo quieras afectar su visibilidad) */
.dropdown-divider {
  border-color: #e3ad6d; /* Cambia el color del divider si es necesario */
}
.rutas {
  color: white;
  font-size: 16;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: 400;
}
.nombreEmpresa {
  color: white;
  font-size: 24;
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-weight: 600;
  letter-spacing: 2px;
}

.espaciado {
  margin-left: 20px;
  margin-bottom: 20px;
}

.navbar {
  position: relative; /* O absolute/fixed según tu necesidad */
  z-index: 1000;
}
</style>
